var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTerms = function SvgTerms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "terms_svg__a",
    x1: "7.986%",
    x2: "92.014%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF444F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "terms_svg__b",
    x1: "0%",
    x2: "100%",
    y1: "50.781%",
    y2: "49.219%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF444F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "terms_svg__c",
    x1: "0%",
    x2: "100%",
    y1: "51.02%",
    y2: "48.98%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF444F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "terms_svg__d",
    x1: "0%",
    x2: "100%",
    y1: "52%",
    y2: "48%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF444F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "terms_svg__e",
    x1: "0%",
    x2: "100%",
    y1: "55.556%",
    y2: "44.444%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF444F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6444"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#terms_svg__a)",
    fillRule: "nonzero",
    d: "M9.02 0c.505 0 .986.203 1.337.56l.093.101 1.348 1.589h1.685c.358.006.699.14.962.376l.107.108L16.79 5.25h.085v.096l.028.031c.193.22.312.492.34.778l.007.143v10.296c0 .774-.636 1.4-1.423 1.406H6.682c-.789 0-1.432-.628-1.432-1.406v-.844H2.167a1.418 1.418 0 0 1-1.412-1.31l-.005-.11V1.447A1.41 1.41 0 0 1 2.033.006L2.159 0H9.02zm4.457 3H6.682A.67.67 0 0 0 6 3.656v12.938c0 .36.303.656.682.656h9.142a.67.67 0 0 0 .676-.656V6.296A.632.632 0 0 0 16.428 6h-1.436c-.727 0-1.345-.489-1.404-1.128l-.005-.102-.069-1.766L13.477 3zM9 .75H2.159a.657.657 0 0 0-.655.595l-.004.093V14.33a.67.67 0 0 0 .584.665l.083.005H5.25V3.656c0-.733.57-1.332 1.294-1.4l.138-.006H9V.75zm5.286 2.813.047 1.192c0 .236.237.455.567.49l.092.005h.794l-1.5-1.687zM9.751 1.02 9.75 2.25h1.065l-.937-1.103a1.171 1.171 0 0 0-.127-.127z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    x: 8.625,
    y: 7.875,
    fill: "url(#terms_svg__b)",
    fillRule: "nonzero",
    rx: 0.375
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.25,
    height: 1,
    x: 8.625,
    y: 9.375,
    fill: "url(#terms_svg__c)",
    fillRule: "nonzero",
    rx: 0.375
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    x: 8.625,
    y: 10.875,
    fill: "url(#terms_svg__b)",
    fillRule: "nonzero",
    rx: 0.375
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.25,
    height: 1,
    x: 8.625,
    y: 12.375,
    fill: "url(#terms_svg__c)",
    fillRule: "nonzero",
    rx: 0.375
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.75,
    height: 1,
    x: 8.625,
    y: 13.875,
    fill: "url(#terms_svg__d)",
    fillRule: "nonzero",
    rx: 0.375
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.25,
    height: 1,
    x: 3.375,
    y: 5.625,
    fill: "url(#terms_svg__e)",
    fillRule: "nonzero",
    rx: 0.375
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.25,
    height: 1,
    x: 3.375,
    y: 7.125,
    fill: "url(#terms_svg__e)",
    fillRule: "nonzero",
    rx: 0.375
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.25,
    height: 1,
    x: 3.375,
    y: 8.625,
    fill: "url(#terms_svg__e)",
    fillRule: "nonzero",
    rx: 0.375
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.25,
    height: 1,
    x: 3.375,
    y: 10.125,
    fill: "url(#terms_svg__e)",
    fillRule: "nonzero",
    rx: 0.375
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.25,
    height: 1,
    x: 3.375,
    y: 11.625,
    fill: "url(#terms_svg__e)",
    fillRule: "nonzero",
    rx: 0.375
  }))));
};

export { SvgTerms as ReactComponent };
export default "data:image/svg+xml;base64,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";